import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../services/archismall.service';
import { AlertService } from '../../../../services/ui/alert.service';
import { StoreService } from '../../../../services/store.service';
import { TableHeaderItem } from '../../../../commons/components/table-component/domain/table-header-item';

export const VerificaDocumentiCaricatiComponent = {
    template: require('./verifica-documenti-caricati.html'),
    controller: class VerificaDocumentiCaricatiController {

        static $inject: string[] = [
            '$scope',
            '$rootScope',
            '$state',
            '$stateParams',
            'store',
            'ArchiSmallServices',
            'AlertService',
            'StoreService',
            '$uibModal'
        ];

        private classeDocumentaleLabels: Record<string, string>;
        private headerColumns: Record<string, Array<TableHeaderItem>>;

        constructor(
            private $scope: any,
            private $rootScope: any,
            private $state: any,
            private $stateParams: ng.ui.IStateParamsService,
            private store: ng.a0.storage.IStoreService,
            private ArchiSmallServices: ArchiSmallServices,
            private alertService: AlertService,
            private storeService: StoreService,
            private $uibModal: ng.ui.bootstrap.IModalService
        ) {
            $scope.showNormalView = true;
            let processingRequest = false;
            $scope.moreDataToLoad = true;
            $rootScope.formsubmitted = false;
            $scope.documents = {
                'verificationConfirm': false
            };
            let fromState = store.get('fromState');

            if (fromState !== undefined) {
                if (fromState === 'home.conservazione-carica-mail-pec-summary' || fromState === 'home.conservazione-carica-documento-step1') {
                    $scope.showNormalView = false;
                }
            }

            this.classeDocumentaleLabels = {
                'mail_pec': 'Mail/PEC'
            };

            this.headerColumns = {
                'mail_pec': [
                    { key: 'metadata.subject', label: 'Oggetto email @PEC', ratio: '34', isSortable: true },
                    { key: 'metadata.sender', label: 'Mittente', ratio: '17', isSortable: true },
                    { key: 'metadata.primary_recipient', label: 'Destinatario primario', ratio: '17', isSortable: true },
                    { key: 'metadata.dataDocumento', label: 'Data', ratio: '10', isSortable: true },
                    { key: 'metadata.receipt', label: 'Ricevuta', ratio: '9', isSortable: true },
                    { key: 'metadata.complete_status', label: 'Stato', ratio: '12', isSortable: true }
                ]
            };

            $scope.invalidItems = [];
            $rootScope.formsubmitted = false;
            $scope.moreDataToLoad = true;
            $scope.selectedItems = [];

            $scope.settings = {
                'filter': {
                    'user': this.storeService.getCurrentUser().sub,
                    'classeDocumentale': $stateParams.classeDocumentale,
                    'fileName': '',
                    'dataDocumentoFrom': '',
                    'dataDocumentoTo': '',
                    'denominazione': '',
                    'stato': '5',
                    'partitaIva': '',
                    'codiceFiscale': '',
                    'tipoDocumento': '',
                    'numeroDocumento': '',
                    'periodo': '',
                    'sender': '',
                    'primaryRecipient': '',
                    'subject': '',
                    'receipt': '',
                    'completeStatus': '',
                    'anno': '',
                    'mese': '',
                    'pageNumber': 1,
                    'pageSize': 100
                },
                'sortField': '_id',
                'sortDirection': -1,
                'pageSizes': [20, 50, 100]
            };

            $scope.openVerificaDocumentiCaricatiFilterModal = (size) => {
                let VerificaDocumentiCaricatiFilterModalInstance = $uibModal.open({
                    animation: true,
                    component: 'verificaDocumentiCaricatiFilterComponent',
                    size: size,
                    windowClass: 'center-modal',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        filter: () => {
                            return $scope.settings;
                        }
                    }
                });
                VerificaDocumentiCaricatiFilterModalInstance.result.then((settings) => {
                    if (settings !== undefined) {
                        $scope.settings = settings;
                        $scope.settings.filter.pageNumber = 1;
                        $scope.getItems();
                        $scope.selectedItems = [];
                    }
                    $scope.invalidItems = [];
                });
            };

            $scope.checkIfItemIsInvalid = (item) => {
                if ($scope.invalidItems.length > 0) {
                    for (let i of $scope.invalidItems) {
                        let index = $scope.invalidItems.indexOf(item._id);
                        if (index > -1) {
                            $scope.invalidItems.splice(index, 1);
                        }
                    }
                }
            };

            $scope.getItems = () => {
                if ($scope.settings.filter.classeDocumentale === '' || processingRequest) {
                    return;
                }

                processingRequest = true;
                ArchiSmallServices.getConservazioneDocuments($scope.settings.filter, $scope.settings.sortField, $scope.settings.sortDirection)
                    .then((response: any) => {
                        if (response.Result === 1) {
                            $scope.settings.itemsCount = response.itemsCount;

                            let items = response.resultList;
                            $scope.items = items;
                            $scope.moreDataToLoad = true;

                            if ($scope.items.length >= $scope.settings.itemsCount) {
                                $scope.moreDataToLoad = false;
                            }
                        }

                        processingRequest = false;
                    }, (error) => {
                        this.alertService.alert('error', error);
                        processingRequest = false;
                    });
            };

            $scope.getItemById = (id) => {
                for (let item in $scope.items) {
                    if ($scope.items[item]._id === id) {
                        $scope.selectedItem = $scope.items[item];
                    }
                }
            };

            let allPECAreCompleted = (itemScope?: any) => {
                if ($scope.items && $scope.selectedItems && $scope.selectedItems.length > 0) {

                    // find selected items with metadata.complete_status = 0
                    let invalidItemsIndexes = $.map($scope.items, (obj, index) => {
                        if (obj.metadata.complete_status === 0 && $.inArray(obj._id, $scope.selectedItems) > -1) {
                            return index;
                        }
                    });
                    return invalidItemsIndexes.length === 0;
                } else
                    if ($scope.items && itemScope !== undefined) {
                        return itemScope.metadata.complete_status === 1;
                    }
                return false;
            };

            let checkIfExistsPecWithStatusDaCompletare = () => {
                if ($scope.items) {
                    // find selected items with metadata.complete_status = 0
                    let invalidItemsIndexes = $.map($scope.items, (obj, index) => {
                        if (obj.metadata.complete_status === 0) {
                            return index;
                        }
                    });
                    return invalidItemsIndexes.length === 0;
                }
                return false;
            };

            $scope.EditMetada = (item) => {
                switch ($scope.settings.filter.classeDocumentale) {
                    case 'mail_pec':
                        $scope.EditPECMetada(item);
                        break;
                    default:
                        break;
                }
            };

            let addIsPEC = (item) => {
                item.metadata.anagrafica.sender.isPEC = false;
                if (item.metadata.anagrafica.sender.email_pec !== undefined && item.metadata.anagrafica.sender.email_pec === item.metadata.sender
                    || (item.metadata.anagrafica.sender.piva === '' && item.metadata.anagrafica.sender.company_name === '' && item.metadata.anagrafica.sender.fiscal_code === '')) {
                    item.metadata.anagrafica.sender.isPEC = true;
                }

                item.metadata.anagrafica.receiver.isPEC = false;
                if (item.metadata.anagrafica.receiver.email_pec !== undefined && item.metadata.anagrafica.receiver.email_pec === item.metadata.primary_recipient
                    || (item.metadata.anagrafica.receiver.piva === '' && item.metadata.anagrafica.receiver.company_name === '' && item.metadata.anagrafica.receiver.fiscal_code === '')) {
                    item.metadata.anagrafica.receiver.isPEC = true;
                }

                return item;
            };

            $scope.EditPECMetada = (item) => {

                item = addIsPEC(item);

                let EditPECMetadaModal = $uibModal.open({
                    animation: true,
                    component: 'editPecMetadataModalComponent',
                    windowClass: 'center-modal',
                    backdrop: 'static',
                    size: 'md',
                    keyboard: false,
                    resolve: {
                        settings: {
                            'item': item
                        }
                    }
                });

                EditPECMetadaModal.result.then((_item) => {
                    if (_item !== undefined && _item.otherDocumentsHaveBeenUpdated === true) {
                        $scope.settings.filter.pageNumber = 1;
                        $scope.getItems();
                    }
                }, () => {
                    // ?
                });
            };

            $scope.clearFilter = () => {
                $scope.settings.filter.fileName = '';
                $scope.settings.filter.dataDocumentoFrom = '';
                $scope.settings.filter.dataDocumentoTo = '';
                $scope.settings.filter.denominazione = '';
                $scope.settings.filter.partitaIva = '';
                $scope.settings.filter.codiceFiscale = '';
                $scope.settings.filter.tipoDocumento = '';
                $scope.settings.filter.numeroDocumento = '';
                $scope.settings.filter.periodo = '';
                $scope.settings.filter.sender = '';
                $scope.settings.filter.primaryRecipient = '';
                $scope.settings.filter.subject = '';
                $scope.settings.filter.receipt = '';
                $scope.settings.filter.completeStatus = '';
                $scope.settings.filter.pageNumber = 1;
                $scope.items = [];
                $scope.moreDataToLoad = true;
                $scope.selectedItems = [];
                $scope.invalidItems = [];
                $scope.getItems();
            };

            $scope.clearSelection = () => {
                $scope.selectedItems = [];
                for (let i = 0; i < $scope.items.length; i++) {
                    $scope.items[i].isSelected = false;
                }
                $scope.selectAllValue = false;
                $scope.invalidItems = [];
            };

            $scope.validaPEC = (itemScope) => {
                let itemIds, allPecMetadataCompleted;

                if (($scope.selectedItems.length === 0 && itemScope === undefined) && $scope.showNormalView) {
                    return;
                }

                if (itemScope !== undefined) {
                    itemIds = [];
                    itemIds.push(itemScope._id);
                    allPecMetadataCompleted = allPECAreCompleted(itemScope);
                } else if ($scope.selectedItems.length > 0) {
                    itemIds = $scope.selectedItems;
                    allPecMetadataCompleted = allPECAreCompleted();
                }

                if (!$scope.showNormalView) {
                    allPecMetadataCompleted = checkIfExistsPecWithStatusDaCompletare();
                }

                if (!allPecMetadataCompleted) {

                    let modalInstance = $uibModal.open({
                        animation: $scope.animationsEnabled,
                        component: 'defaultModalComponent',
                        windowClass: 'center-modal',
                        backdrop: 'static',
                        keyboard: false,
                        resolve: {
                            config: () => {
                                return {
                                    headerIcon: 'fa fa-exclamation-triangle',
                                    headerText: 'Attenzione',
                                    bodyText: 'Se non hai compilato le info anagrafiche richieste, i documenti saranno conservati riportando sull\'Indice di Conservazione solo gli indirizzi mail. Accetti di procedere?',
                                    buttons: [
                                        {
                                            'id': 1,
                                            'icon': 'fa fa-ban',
                                            'label': 'No'
                                        },
                                        {
                                            'id': 2,
                                            'icon': 'fa fa-check-circle-o',
                                            'label': 'Si'
                                        }
                                    ]
                                };
                            }
                        }
                    });
                    modalInstance.result.then((pressedButtonId) => {
                        if (pressedButtonId !== undefined) {
                            if (pressedButtonId === 2) {
                                let email = store.get('user').accountData.email;

                                $uibModal.open({
                                    animation: true,
                                    component: 'workerValidaPecModalComponent',
                                    windowClass: 'center-modal',
                                    backdrop: 'static',
                                    keyboard: false,
                                    resolve: {
                                        settings: () => {
                                            return {
                                                'user': email,
                                                'items': itemIds
                                            };
                                        },
                                        option: () => {
                                            if (!$scope.showNormalView) {
                                                return 'all';
                                            }
                                            return null;
                                        }
                                    }
                                });
                            }
                        }
                    }, () => {
                        // ??
                    });
                } else {
                    let email = store.get('user').accountData.email;

                    $uibModal.open({
                        animation: true,
                        component: 'workerValidaPecModalComponent',
                        windowClass: 'center-modal',
                        backdrop: 'static',
                        keyboard: false,
                        resolve: {
                            settings: () => {
                                return {
                                    'user': email,
                                    'items': itemIds
                                };
                            },
                            option: () => {
                                if (!$scope.showNormalView) {
                                    return 'all';
                                }
                                return null;
                            }
                        }
                    });
                }
            };

            $scope.delete = (itemScope) => {
                let itemsSelected = [];
                let msg: string = '';
                if ($scope.selectedItems.length > 1) {
                    itemsSelected = $scope.selectedItems;
                    msg = 'Confermi l’eliminazione dei documenti selezionati?';
                } else {
                    if (itemScope !== undefined) {
                        itemsSelected.push(itemScope._id);
                        msg = 'Confermi l’eliminazione di ' + itemScope.fileName + ' ?';
                    } else {
                        itemsSelected.push($scope.selectedItem._id);
                        msg = 'Confermi l’eliminazione di ' + $scope.selectedItem.fileName + ' ?';
                    }
                }

                let modalInstance = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    component: 'defaultModalComponent',
                    windowClass: 'center-modal',
                    resolve: {
                        config: () => {
                            return {
                                headerIcon: 'fa fa-exclamation-triangle',
                                headerText: 'Richiesta Conferma',
                                bodyHtml: '<i class=\'fa fa-exclamation-triangle\'></i> ' + msg,
                                buttons: [
                                    {
                                        'id': 1,
                                        'icon': 'fa fa-ban',
                                        'label': 'Annulla'
                                    },
                                    {
                                        'id': 2,
                                        'icon': 'fa fa-check-circle-o',
                                        'label': 'Ok'
                                    }
                                ]
                            };
                        }
                    }
                });
                modalInstance.result.then((pressedButtonId) => {
                    if (pressedButtonId !== undefined && pressedButtonId === 2) {
                        if (itemsSelected.length > 0) {
                            switch ($scope.settings.filter.classeDocumentale) {
                                case 'mail_pec':
                                    ArchiSmallServices.deleteFattureAttive(itemsSelected)
                                        .then((response: any) => {
                                            $scope.settings.filter.pageNumber = 1;
                                            $scope.getItems();
                                            if ($scope.invalidItems.length > 0) {
                                                for (let i of itemsSelected) {
                                                    $scope.checkIfItemIsInvalid(itemsSelected[i]);
                                                }
                                            }
                                            $scope.selectedItems = [];
                                        }, (error) => {
                                            this.alertService.alert('error', error);
                                        });
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                    // alert('We have to call a WS here ... Set the WS and unncomment following lines!');
                }, () => {
                    // ?
                });
            };

            $scope.getItems();

            $scope.contextMenuItemTitle = '<span><strong class=\'centered\'>' + $scope.selectedItems.length + ' items selected</strong></span>';
            $scope.contextMenuOptions = (item, index) => {
                if ($scope.selectedItems.length > 1) {
                    $scope.menuOptionsMultiple[0][0] = '<span><strong>Documenti multipli (' + $scope.selectedItems.length + ')</strong></span>';
                    return $scope.menuOptionsMultiple;
                } else {
                    if (item.fileName !== undefined) {
                        let filenameLength = item.fileName.length;
                        let filename = '';
                        if (filenameLength > 23) {
                            filename = item.fileName.substr(0, 10).trim() + '...' + item.fileName.substr(filenameLength - 10, filenameLength).trim();
                        }

                        filename = filename !== '' ? filename : item.fileName;
                        $scope.menuOptionsSingle[0][0] = '<span><strong>' + filename + '</strong></span>';
                    } else {
                        $scope.menuOptionsSingle[0][0] = '<span><strong>Documento ' + ++index + '</strong></span>';
                    }
                    return $scope.menuOptionsSingle;
                }
            };

            $scope.contextMenuItemValidatePEC = '<i class=\'fa fa-fw fa-check-square-o\'></i> <span>Valida PEC</span>';
            $scope.contextMenuItemEdit = '<i class=\'icon-icon_modifica\'></i> <span>Modifica</span>';
            $scope.contextMenuItemDelete = '<i class=\'icon-icon_erase\'></i> <span>Rimuovi</span>';
            $scope.menuOptionsSingle = [
                [$scope.contextMenuItemTitle, ($itemScope) => {
                    //
                }],
                null,
                [$scope.contextMenuItemValidatePEC, ($itemScope) => {
                    $scope.validaPEC($itemScope.item);
                }],
                null,
                [$scope.contextMenuItemEdit, ($itemScope) => {
                    $scope.EditMetada($itemScope.item);
                }],
                null,
                [$scope.contextMenuItemDelete, ($itemScope) => {
                    $scope.delete($itemScope.item);
                }]
            ];
            $scope.menuOptionsMultiple = [
                [$scope.contextMenuItemTitle, () => {
                    // title
                }],
                null,
                [$scope.contextMenuItemValidatePEC, ($itemScope) => {
                    $scope.validaPEC();
                }],
                null,
                [$scope.contextMenuItemDelete, ($itemScope) => {
                    $scope.delete();
                }]
            ];

            $scope.addOrRemoveSelectedItems = (item) => {
                if (item.isSelected) {
                    if ($scope.selectedItems.indexOf(item._id) === -1) {
                        $scope.selectedItems.push(item._id);
                    }
                    if ($scope.selectedItems.length === 1) {
                        $scope.selectedItem = item;
                    }
                } else {
                    if ($scope.selectedItems.length === 1) {
                        $scope.selectedItem = {};
                    }
                    let index = $scope.selectedItems.indexOf(item._id);
                    $scope.selectedItems.splice(index, 1);
                }
            };
        }

        goToConservazioneSection() {
            this.$state.go('home.conservazione');
        }
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/verifica-documenti-caricati/verifica-documenti-caricati.ts